// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ReferralRewardReceiveCompleteEvent
 */
export var ReferralRewardReceiveComplete = function (_a) {
    var clientScenario = _a.clientScenario, duration = _a.duration, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source;
    return ({
        name: "ReferralReward Receive Complete",
        parameters: {
            cdf_entity: "ReferralReward",
            cdf_action: "Receive",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration: duration !== undefined && duration !== null ? duration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ReferralRewardReceiveStartEvent
 */
export var ReferralRewardReceiveStart = function (_a) {
    var clientScenario = _a.clientScenario, duration = _a.duration, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source;
    return ({
        name: "ReferralReward Receive Start",
        parameters: {
            cdf_entity: "ReferralReward",
            cdf_action: "Receive",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration: duration !== undefined && duration !== null ? duration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ReferralRewardReceiveSkipEvent
 */
export var ReferralRewardReceiveSkip = function (_a) {
    var clientScenario = _a.clientScenario, duration = _a.duration, flowToken = _a.flowToken, ratePlan = _a.ratePlan, source = _a.source;
    return ({
        name: "ReferralReward Receive Skip",
        parameters: {
            cdf_entity: "ReferralReward",
            cdf_action: "Receive",
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration: duration !== undefined && duration !== null ? duration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            rate_plan: ratePlan !== undefined && ratePlan !== null ? ratePlan.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ReferralRewardReceiveViewStatusEvent
 */
export var ReferralRewardReceiveViewStatus = function () { return ({
    name: "ReferralReward Receive ViewStatus",
    parameters: {
        cdf_entity: "ReferralReward",
        cdf_action: "Receive",
    }
}); };
/**
 * @see ReferralRewardReceiveCompleteStatusEvent
 */
export var ReferralRewardReceiveCompleteStatus = function (_a) {
    var duration = _a.duration, rewardPaymentAmount = _a.rewardPaymentAmount, rewardPaymentCurrencyCode = _a.rewardPaymentCurrencyCode, totalPayments = _a.totalPayments;
    return ({
        name: "ReferralReward Receive CompleteStatus",
        parameters: {
            cdf_entity: "ReferralReward",
            cdf_action: "Receive",
            duration: duration !== undefined && duration !== null ? duration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reward_payment_amount: rewardPaymentAmount !== undefined && rewardPaymentAmount !== null ? rewardPaymentAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reward_payment_currency_code: rewardPaymentCurrencyCode !== undefined && rewardPaymentCurrencyCode !== null ? rewardPaymentCurrencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            total_payments: totalPayments !== undefined && totalPayments !== null ? totalPayments.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ReferralRewardReceiveViewProgressEvent
 */
export var ReferralRewardReceiveViewProgress = function () { return ({
    name: "ReferralReward Receive ViewProgress",
    parameters: {
        cdf_entity: "ReferralReward",
        cdf_action: "Receive",
    }
}); };
